import defaultConfig from '@/config/defaultConfig';
import tenants from '@/config/tenants.js';

export const configGetter = (tenantId, themeId) => ({
  ...(tenants[tenantId] || {}),
  ...(defaultConfig.themeConfig[themeId] || {}),
  ...defaultConfig.widgetConfiguration
});
